/** Only allow same-origin relative redirects (prevents open redirects). */
export function safeRedirect(target: string | undefined | null, fallback = '/'): string {
  if (!target || typeof target !== 'string') return fallback
  if (!target.startsWith('/') || target.startsWith('//') || target.startsWith('/\\')) return fallback
  if (target.startsWith('/login') || target.startsWith('/register')) return fallback
  return target
}
